import { Component } from '@angular/core';
import { LogoComponent } from '../svg/logo';

@Component({
  selector: 'app-footer',
  imports: [LogoComponent],
  templateUrl: './footer.html',
  styleUrl: './footer.scss'
})
export class Footer {

}
